<template>
  <div>
    <!-- -------------------------------------------- ||CARD|| ---------------------------------------------------->
    <div class="card rounded-xl" elevation="1">
      <v-container>
        <div class="my-10">
          <div class="result12">
            <v-row>
              <!-- {{ winNumberParts }} -->
              <!-- {{ result12[1].winNumberPowerball }} -->
              <v-col cols="12" md="3">
                <div class="z_card pr-5 mr-5">
                  <div class="mr-3">
                    <img
                      :src="
                        getZodiacIcon(Number(result12[1]?.winNumberPowerball))
                      "
                      style="width: 100px"
                    />
                  </div>
                  <div>
                    <div style="display: flex; justify-content: center">
                      <strong>ລາສີ</strong>
                    </div>
                    <div style="display: flex; justify-content: center">
                      <span class="z_name">
                        <b>{{
                          getZodiacName(Number(result12[1]?.winNumberPowerball))
                        }}</b>
                      </span>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-divider vertical  class="d-none d-md-flex"></v-divider>
              <v-col cols="12" md="9" align-self="center">
                <div>
                  <v-row>
                    <v-col
                      class="text-center"
                      v-for="(item, index) in winNumberParts"
                      :key="index"
                    >
                      <div class="px-2">
                        <v-row>
                          <v-col cols="2" class="pa-0">
                            <div style="display: flex; justify-content: center">
                              <div class="fontStyle" color="#9e1c20">
                                {{ item[0] }}
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="2" class="pa-0">
                            <div style="display: flex; justify-content: center">
                              <div class="fontStyle" color="#9e1c20">
                                {{ item[1] }}
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="2" class="pa-0">
                            <div style="display: flex; justify-content: center">
                              <div class="fontStyle" color="#9e1c20">
                                {{ item[2] }}
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="2" class="pa-0">
                            <div style="display: flex; justify-content: center">
                              <div class="fontStyle" color="#9e1c20">
                                {{ item[3] }}
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="2" class="pa-0">
                            <div style="display: flex; justify-content: center">
                              <div class="fontStyle" color="#9e1c20">
                                {{ item[4] }}
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="2" class="pa-0">
                            <div style="display: flex; justify-content: center">
                              <div class="fontStyle" color="#9e1c20">
                                {{ item[5] }}
                              </div>
                            </div>
                          </v-col>
                        </v-row>

                        <!-- <div style="display: flex; justify-content: center;">
                      <div
                        class="laseeCard text-center mt-2"
                        outlined
                        elevation="0"
                        color="error"
                      >
                        {{ getZodiacName(Number(item)) }}
                      </div>
                    </div> -->
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      zodiac: [
        {
          id: 1,
          name: "ຊວດ",
          // zicon: require("../../assets/zodiac/Asset1.png"),
          zicon: require("../../assets/zodiac/zodiac_1.webp"),
        },
        {
          id: 2,
          name: "ສະຫລູ",
          zicon: require("../../assets/zodiac/zodiac_2.webp"),
        },
        {
          id: 3,
          name: "ຂານ",
          zicon: require("../../assets/zodiac/zodiac_3.webp"),
        },
        {
          id: 4,
          name: "ເຖາະ",
          zicon: require("../../assets/zodiac/zodiac_4.webp"),
        },
        {
          id: 5,
          name: "ມະໂລງ",
          zicon: require("../../assets/zodiac/zodiac_5.webp"),
        },
        {
          id: 6,
          name: "ມະເສັງ",
          zicon: require("../../assets/zodiac/zodiac_6.webp"),
        },
        {
          id: 7,
          name: "ມະເມຍ",
          zicon: require("../../assets/zodiac/zodiac_7.webp"),
        },
        {
          id: 8,
          name: "ມະແມ",
          zicon: require("../../assets/zodiac/zodiac_8.webp"),
        },
        {
          id: 9,
          name: "ວອກ",
          zicon: require("../../assets/zodiac/zodiac_9.webp"),
        },
        {
          id: 10,
          name: "ລະກາ",
          zicon: require("../../assets/zodiac/zodiac_10.webp"),
        },
        {
          id: 11,
          name: "ຈໍ",
          zicon: require("../../assets/zodiac/zodiac_11.webp"),
        },
        {
          id: 12,
          name: "ກຸນ",
          zicon: require("../../assets/zodiac/zodiac_12.webp"),
        },
      ],
    };
  },

  computed: {
    ...mapGetters("main_result12", ["result12", "textt"]),
    formattedRoundDate() {
      return moment(this.result12[1]?.roundDate).format("DD/MM/YYYY");
    },
    getZodiacNameFromWinNumber() {
      const id = this.result12[1]?.winNumber.split(".")[0];
      return this.getZodiacName(Number(id));
    },
    winNumberParts() {
      return this.result12[1]?.winNumber.split(".") || [];
    },
  },

  methods: {
    ...mapActions("main_result12", ["MainResult"]),
    getZodiacName(id) {
      const zodiac = this.zodiac.find((z) => z.id === id);
      return zodiac ? zodiac.name : "- - -";
    },
    getZodiacIcon(id) {
      const zodiac = this.zodiac.find((z) => z.id === id);
      return zodiac ? zodiac.zicon : "";
    },
  },
  async mounted() {
    await this.MainResult();
  },

  destroyed() {
    window?.removeEventListener("resize", this.myEventHandlerResizeScreen);
  },
};
</script>

<style lang="scss" scoped>
.z_card {
  display: flex;
  justify-content: center;
  // border-right: 2px rgb(206, 206, 206) solid;
  .z_name {
    padding: 0 10px 0 10px;
    border-radius: 10px;
    border: 1px solid #00adef;
    background-color: #fff;
    filter: drop-shadow(0 0 0.2rem rgb(180, 180, 180));
  }
  strong {
    font-size: 20pt;
  }
  b {
    color: #00adef;
    font-size: 25pt;
  }
}

.laseeCard {
  font-weight: bold;
  color: #9e1c20;
  border: 2px solid #00adef;
  padding: 3px;
  border-radius: 5px;
  width: 60px;
}

.fontStyle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  font-size: 20pt;
  font-weight: bold;
  color: #fff;
  background-color: #00adef;
  border-radius: 200px;
}

.result12 {
  display: flex;
  justify-content: center;
}

.header {
  color: #ffc308;
}

.btn {
  color: white;
}

* {
  -webkit-user-drag: none;
}
</style>
